/// <summary>
/// 11111111 : all week days active
/// 00000001 : sunday active
/// 01000000 : saturday active
/// 00010010 : monday & thursday active
/// 00000000 : noweek day active (non sense)
/// </summary>
const  TIME_CONSTRAINT_TYPES = {
	UNDEFINED : { value : 0, text: "UNDEFINED", key: "UNDEFINED"},
	MEDIA : { value : 10, text: "MEDIA", key: "MEDIA"},
	BOX : { value : 20, text: "BOX", key: "BOX"},
	BOX_MEDIA : { value : 21, text: "BOX_MEDIA", key: "BOX_MEDIA"},
	CLOCK : { value : 30, text: "CLOCK", key: "CLOCK"},
	CLOCK_BOX : { value : 31, text: "CLOCK_BOX", key: "CLOCK_BOX"},
	DAY_TEMPLATE : { value : 40, text: "DAY_TEMPLATE", key: "DAY_TEMPLATE"},
	DAY_TEMPLATE_CLOCK : { value : 41, text: "DAY_TEMPLATE_CLOCK", key: "DAY_TEMPLATE_CLOCK"},
};

const ALL_WEEKDAYS_ON = parseInt('01111111', 2) // FIRST BIT = 1 FOR TEST PERPOSE
const WEEKDAYS_ON = parseInt('00011111', 2)
const WEEKEND_ON = parseInt('01100000', 2)

const DAY_OF_WEEK_MASKS =
{
    SUNDAY: 1,
    MONDAY: 2,
    TUESDAY: 4,
    WEDNESDAY: 8,
    THURSDAY: 16,
    FRIDAY: 32,
    SATURDAY: 64,
}

/// <summary>
/// One 32 bits mask per month.
/// 00000000 00000000 00000000 00000001 : first day of month activated
/// 01000000 00000000 00000000 00000001 : first day of month and the 31st activated
/// 01111111 11111111 11111111 11111111 : all days of month activated
/// </summary>
const MONTH_31 = parseInt('01111111111111111111111111111111', 2);
const MONTH_30 = parseInt('00111111111111111111111111111111', 2);
const MONTH_29 = parseInt('00011111111111111111111111111111', 2);
const DAY_OF_MONTH_MASKS = {
    1: MONTH_31,
    2: MONTH_29,
    3: MONTH_31,
    4: MONTH_30,
    5: MONTH_31,
    6: MONTH_30,
    7: MONTH_31,
    8: MONTH_31,
    9: MONTH_30,
    10: MONTH_31,
    11: MONTH_30,
    12: MONTH_31
}
// console.log("Day of month mask :",DAY_OF_MONTH_MASKS)
/// <summary>
/// Per 1/2h : 48 periods of 30 minutes
/// The day starts from midnight to midnight (nomore from 5:00 to 5:00)
/// <unused> <--------------------------- data --------------------------->
/// 00000000 00000000 11111111 11111111 11111111 11111111 11111111 11111111 : toutes les périodes actives
/// 00000000 00000000 00000000 00000000 00000000 00000000 00000000 00000001 : période de 00:00 à 00:30 active (période 0)
/// 00000000 00000000 00000000 00000000 00000000 00000000 00000001 00000001 : période de 00:00 à 00:30 et de 4:00 à 4:30 active
/// 00000000 00000000 00000000 00000000 00000000 00000000 00000000 00000000 : aucune période active
/// </summary>

//=================================================================================================================================
//--> limitation of JS : 32 bitwise operations
//=================================================================================================================================
//--> must split the default periods using to ints
//const PERIODS_ON = parseInt("000000000000000011111111111111111111111111111111111111111111111111111111", 2)
const PERIODS_ON = parseInt("111111111111111111111111", 2);
// const PERIODS_OFF=parseInt("0000000000000000000000000000000000000000000000000000000000000000", 2)
//=================================================================================================================================
const DEFAULT_CONSTRAINT = {
    priority: 0, // i32
    absoluteFrom: null,
    absoluteTo: null,
    constrainedItemId: null,
    periodOfDayMask: {
      beforeMidDay: PERIODS_ON,
      afterMidDay: PERIODS_ON
    },
    dayOfMonthMask01: DAY_OF_MONTH_MASKS[1],
    dayOfMonthMask02: DAY_OF_MONTH_MASKS[2],
    dayOfMonthMask03: DAY_OF_MONTH_MASKS[3],
    dayOfMonthMask04: DAY_OF_MONTH_MASKS[4],
    dayOfMonthMask05: DAY_OF_MONTH_MASKS[5],
    dayOfMonthMask06: DAY_OF_MONTH_MASKS[6],
    dayOfMonthMask07: DAY_OF_MONTH_MASKS[7],
    dayOfMonthMask08: DAY_OF_MONTH_MASKS[8],
    dayOfMonthMask09: DAY_OF_MONTH_MASKS[9],
    dayOfMonthMask10: DAY_OF_MONTH_MASKS[10],
    dayOfMonthMask11: DAY_OF_MONTH_MASKS[11],
    dayOfMonthMask12: DAY_OF_MONTH_MASKS[12],
    dayOfWeekMask: ALL_WEEKDAYS_ON
};
export default {
    DAY_OF_MONTH_MASKS,
    WEEKDAYS_ON, 
    DAY_OF_WEEK_MASKS,
    WEEKEND_ON,
    ALL_WEEKDAYS_ON,
    PERIODS_ON,
    MONTH_31, 
    MONTH_30, 
    MONTH_29,
    DEFAULT_CONSTRAINT,
    TIME_CONSTRAINT_TYPES
}
